import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ColorFillPropertyType} from '@Components/color-fill';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';

interface LayoutBackgroundColorOptionProps {
  onClickColorFill(): void;
  backgroundColor: RGBA;
  isDisabled?: boolean;
  className?: string;
}

export function LayoutBackgroundColorOption({className = '', isDisabled = false, ...props}: LayoutBackgroundColorOptionProps): ReactElement<any> | null {
  const getColorObject = (): ColorFillStorage[] => {
    return [
      {
        id: 'background-color-menu',
        fillType: ColorFillPropertyType.SOLID,
        color: getColorObjectArrayFromFillColor([props.backgroundColor]),
      },
    ];
  };

  const getColorOption = (): ReactElement<any> => {
    return (
      <ContextualMenuColorFillOption
        className={className}
        isDisabled={isDisabled}
        id="menu-background-color-suboption"
        label={window.i18next.t('pmwjs_color')}
        data={getColorObject()}
        onClick={(): void => {
          props.onClickColorFill();
        }}
      />
    );
  };

  return getColorOption();
}
